import logdown from 'logdown';
export default logdown('browser', {
  prefixColor: '#ff0000'
});